// Dashboard + tenant-page UI locales. BCP-47 script subtags — region-neutral
// so a HK shop, a TW shop, and a Macau shop all share one Traditional Chinese
// surface. Distinct from the AI customer-facing language enum (see
// apps/web/src/lib/ai/i18n.ts) which adds `yue` for spoken Cantonese.
export const locales = ['zh-Hant', 'zh-Hans', 'en'] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = 'en'

export const localeNames: Record<Locale, string> = {
  'zh-Hant': '繁體中文',
  'zh-Hans': '简体中文',
  'en': 'English',
}

export function isValidLocale(v: string): v is Locale {
  return locales.includes(v as Locale)
}
